export const ProductCategory = {
    Trending : 1,
    NewArrival : 2,
    BestSeller : 3,

}

export const ProductCategoryNames = {
    BestSellers: "Best Sellers",
    NewArrivals: "New Arrivals",
    Trending: "Trending",
}